import { Component, OnInit, ViewChild, } from '@angular/core';
import { PraService } from '../services/pra.service';
import { AuthenticationService } from '../services/authentication.service';
import { FormatDataService } from '../services/format-data.service';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { style, animate, animation, animateChild, useAnimation, group, sequence, transition, state, trigger, query as q, stagger } from '@angular/animations';
//Format Time with momentJS
import * as moment from 'moment'

const query = (s, a, o = { optional: true }) => q(s, a, o);

@Component({
  selector: 'app-pra-new-request',
  templateUrl: './pra-new-request.component.html',
  animations: [
    // nice stagger effect when showing existing elements
    trigger('list', [
      transition(':enter', [
        // child animation selector + stagger
        query('@items',
          stagger(300, animateChild())
        )
      ]),
    ]),
    trigger('items', [
      // cubic-bezier for a tiny bouncing feel
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),
        animate('1s cubic-bezier(.8,-0.6,0.2,1.2)',
          style({ transform: 'scale(1)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate('1s cubic-bezier(.8,-0.6,0.2,1.5)',
          style({ transform: 'scale(0.5)', opacity: 0, height: '0px', margin: '0px' }))
      ]),
    ])
  ],
  styleUrls: ['./pra-new-request.component.css']
})
export class PraNewRequestComponent implements OnInit {

  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  //Current User
  currentUser: any;

  //Lists
  employeeList: any[];
  storeList: any = [];
  praWeeks: any[];
  praDays: any[];
  params: any;

  //Form variables
  selectedEmployee: number;
  selectedEmployeeName: string;
  selectedIndex: number;
  selectedEmployeeHomeStore;
  selectedStoreIndex: number;
  selectedPraWeekIndex: number;
  selectedPraWeek: any;
  selectedPraWeekSnapshot: any;
  selectedPraWeekIndexSnapshot: any;
  selectedStore: any;
  selectedStoreState: any;
  storeId: any;
  punchIn = { hour: 8, minute: 0 };
  punchOut = { hour: 8, minute: 10 };
  selectedPunchIn: string = this.formatDataService.formatTime(this.punchIn);
  selectedPunchOut: string = this.formatDataService.formatTime(this.punchOut);
  selectedBusinessDate: any;
  selectedBusinessDateIndex: number;
  comments: string;

  //Punch Records Array
  punchRecordList = [
    {
      selectedBusinessDate: null,
      selectedBusinessDateIndex: null,
      punchIn: { hour: 8, minute: 0 },
      punchOut: { hour: 8, minute: 10 },
    }
  ]
  punchRecordsToView: any = [
    { Hours: null }, { Hours: null }, { Hours: null }
  ];
  punchRecordHours = [];
  totalHours: any;

  //Flags
  isWeekly: boolean = true;
  showPunchRecordGrid: boolean = false;
  showDeleteButton: boolean = false;
  showAddButton: boolean = true;
  showTotalHoursValidation: boolean = false;
  showPunchError: boolean = false;
  continueToNextPage: boolean = true;
  showPunchTimeError: any = null;
  showPunchIsNextDay: any = null;
  showMealBreakAlert: any = null;
  show3AMAlert: any = null;

  //Form validation
  validationComments: boolean = false;
  validationPunchRecords: boolean = false;

  //Views
  selectStoreView: boolean = false;
  addRequestView: boolean = false;

  //Error handling variables
  consentErrMsg = '';

  // Get Today's Date Variables
  todayDate: any = moment().format('MM/DD/YYYY');

  //PRA Week check modal
  @ViewChild('weekAlert') weekAlert: NgbModalRef;
  modalOption: NgbModalOptions = {};
  closeResult: string;


  constructor(
    private PraService: PraService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private formatDataService: FormatDataService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    //Show loading screen
    this.loading = true;

    //Set flags to false
    this.showTotalHoursValidation = false;
    this.showPunchError = false;

    //Initialize all variables
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.currentUser);

    //Redirect if no permission to view page
    if (this.currentUser.payrolladmin == true && this.currentUser.payrollsuperadmin == true) {
      this.storeList = this.PraService.getStores();
    } else if (this.currentUser.payrolladmin == true) {
      this.router.navigate(['/view-adjustment-records']);
    } else if (this.currentUser.payrollsuperadmin == true) {
      this.storeList = this.PraService.getStores();
    } else if (this.currentUser.canRequestNew == false) {
      this.router.navigate(['/view-adjustment-records']);
    } else {
      this.storeList = this.PraService.getStores();
    }

    //Grab URL params if any
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.params = params;
    })

    //If user has only 1 store
    if (this.storeList.length == 1) {
      //Set views
      this.loading = true;
      this.selectStoreView = false;
      this.addRequestView = true;
      //Set store ID for PIC
      this.storeId = this.currentUser.storeList[0].StoreID;

      //If URL params exist then populate forms to maintain state
      if (typeof this.params.AssociateEmployeeID !== 'undefined') {
        this.comments = this.params.Comments;
        this.punchIn = { hour: parseInt(this.params.PunchInHour), minute: parseInt(this.params.PunchInMinute) };
        this.punchOut = { hour: parseInt(this.params.PunchOutHour), minute: parseInt(this.params.PunchOutMinute) };
        console.log({ hour: this.params.PunchOutHour, minute: this.params.PunchOutMinute });
        console.log(this.punchOut);
        this.totalHours = this.params.TotalHours;

        //Read punch records from session storage
        this.punchRecordsToView = JSON.parse(sessionStorage.getItem('punchRecords'));

        //Make sure Delete button shows when punch record list is more than 1
        console.log(this.punchRecordsToView.length);
        if (this.punchRecordsToView.length > 1) {
          this.showDeleteButton = true;
        } else {
          this.showDeleteButton = false;
        }
      }

      //Get employeelist
      this.getEmployeeList();

      //If user has multiple stores
    } else {
      //Set views
      this.selectStoreView = true;
      this.addRequestView = true;

      //If URL params exist then populate forms to maintain state
      if (typeof this.params.AssociateEmployeeID !== 'undefined') {
        this.selectedStore = this.storeList[this.params.StoreIndex].StoreID;
        this.storeId = this.storeList[this.params.StoreIndex].StoreID;
        this.selectedIndex = this.params.Index;
        this.selectedStoreIndex = this.params.StoreIndex;
        this.comments = this.params.Comments;
        this.punchIn = { hour: this.params.PunchInHour, minute: this.params.PunchInMinute };
        this.punchOut = { hour: this.params.PunchOutHour, minute: this.params.PunchOutMinute };
        this.totalHours = this.params.TotalHours;
        this.selectedStoreState = this.storeList[0].State;

        //Read punch records from session storage
        this.punchRecordsToView = JSON.parse(sessionStorage.getItem('punchRecords'));

        //Make sure Delete button shows when punch record list is more than 1
        console.log(this.punchRecordsToView.length);
        if (this.punchRecordsToView.length > 1) {
          this.showDeleteButton = true;
        } else {
          this.showDeleteButton = false;
        }

      } else {
        this.selectedStore = this.storeList[0].StoreID;
        this.storeId = this.storeList[0].StoreID;
        this.selectedIndex = 0;
        this.selectedStoreIndex = 0;
        this.selectedStoreState = this.storeList[0].State;
      }

      //Get employeelist
      this.getEmployeeList();

      console.log(this.storeList);
    }
  }


  selectStore(evt) {
    this.storeId = evt
    //Find Store Index
    let list = this.storeList.filter(i => i.StoreID === evt)[0];
    console.log(list);
    this.selectedStoreIndex = this.storeList.indexOf(list);
    this.selectedStoreState = list.State;
    console.log(list.State);

    this.getEmployeeList();

    //Loading
    this.loading = true;
  }

  selectEmployee(evt) {
    //Find employee in array
    let list = this.employeeList.filter(i => i.EmployeeID === evt)[0];
    console.log(list);
    this.selectedEmployeeName = list.DisplayName;
    this.selectedIndex = this.employeeList.indexOf(list);
    this.isWeekly = list.IsWeekly;
    this.selectedEmployeeHomeStore = list.HomeStoreID;

    //Reset punch record list when choosing a new employee
    this.punchRecordList = [
      {
        selectedBusinessDate: null,
        selectedBusinessDateIndex: null,
        punchIn: { hour: 8, minute: 0 },
        punchOut: { hour: 8, minute: 10 },
      }
    ]
    console.log(list.IsWeekly);
    console.log(this.selectedEmployeeHomeStore);
    this.getPraWeeks();
  }

  praWeekCheck(evt) {
    console.log(this.closeResult)
    //take snapshot of PRA week index
    let week = this.selectedPraWeekSnapshot;
    let weekIndex = this.selectedPraWeekIndexSnapshot;
    console.log(weekIndex)

    //see if user has more than one punch record
    if (this.punchRecordsToView.length > 1) {
      //show modal
      const modal = this.modalService.open(this.weekAlert);
      modal.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
        this.selectPraWeek(result);
        console.log(result)
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        console.log(this.closeResult)
        // if user dismisses modal then switch PRA week back to original
        // go back to orginal week
        this.selectedPraWeek = week;
        this.selectedPraWeekIndex = weekIndex;
        console.log(weekIndex)
      });

    } else {
      this.selectPraWeek(evt);
    }

  }

  selectPraWeek(evt) {
    console.log(evt);
    console.log(this.selectedPraWeek);
    this.selectedPraWeekIndex = this.praWeeks.indexOf(evt);
    //snapshot created for alert
    this.selectedPraWeekSnapshot = evt;
    this.selectedPraWeekIndexSnapshot = this.praWeeks.indexOf(evt);
    console.log(this.selectedPraWeekIndex);
    this.praDays = this.formatDataService.createDaysOfPayWeek(evt, this.isWeekly)
    console.log(this.formatDataService.createDaysOfPayWeek(evt, this.isWeekly));
    console.log(this.punchRecordList[0].selectedBusinessDate);
    console.log(this.praDays[0])

    //change date on view model
    let changeDateOnModel = []
    for (let index in this.punchRecordList) {
      changeDateOnModel.push({
        selectedBusinessDate: this.praDays[0],
        selectedBusinessDateIndex: this.punchRecordList[index].selectedBusinessDateIndex,
        punchIn: this.punchRecordList[index].punchIn,
        punchOut: this.punchRecordList[index].punchOut,
      })
    }
    this.punchRecordList = changeDateOnModel

    //Change session storage data with each event change
    this.addInitialSessionStorage();
  }

  selectBusinessDate(evt) {
    console.log(evt);
    this.selectedBusinessDateIndex = this.praDays.indexOf(evt);

    //Change session storage data with each event change
    this.addInitialSessionStorage();
  }

  changePunchIn(evt) {
    try {
      this.showPunchError = false;
      this.selectedPunchIn = this.formatDataService.formatTime(evt);
      this.punchIn = evt;


    }
    catch (err) {
      this.showPunchError = true;
      console.log(err);
    }

    //Change session storage data with each event change
    this.addInitialSessionStorage();


  }

  changePunchOut(evt) {
    try {
      this.showPunchError = false;
      this.selectedPunchOut = this.formatDataService.formatTime(evt);
      this.punchOut = evt;

    }
    catch (err) {
      this.showPunchError = true;
      console.log(err);
    }
    //Change session storage data with each event change
    this.addInitialSessionStorage();
  }

  addInitialSessionStorage() {
    console.log(this.punchRecordList);
    //Remove any session storage
    sessionStorage.removeItem("punchRecords");

    //Format punchRecordList
    this.convertPunchRecordsFormat();

    //Get total hours
    this.getPunchRecordsHours();

    //Add default record to session storage
    sessionStorage.setItem('punchRecords', JSON.stringify(this.punchRecordsToView));
    console.log(this.punchRecordsToView);
  }

  //Use local storage to store punch record arrays
  addPunchRecordItem() {

    //Grab Punch Records from Local Storage if it exists
    if (sessionStorage.punchRecords != null) {
      this.punchRecordsToView = JSON.parse(sessionStorage.getItem('punchRecords'));
    }

    // New default punch record variable
    let newItem = {
      selectedBusinessDate: this.praDays[0],
      selectedBusinessDateIndex: null,
      punchIn: { hour: 9, minute: 0 },
      punchOut: { hour: 9, minute: 10 }
    }

    //Push new default record to data array
    this.punchRecordList.push(newItem)

    //Update formatted punchRecordList
    this.convertPunchRecordsFormat();

    //Get total hours
    this.getPunchRecordsHours();

    //If records exist in Local Storage then erase it
    if (sessionStorage.punchRecords != null) {
      sessionStorage.removeItem("punchRecords");
    }

    //Add record to local storage
    sessionStorage.setItem('punchRecords', JSON.stringify(this.punchRecordsToView));

    //If more than one item in array, show Delete button
    if (this.punchRecordList.length > 1) {
      this.showDeleteButton = true;
    }

    //Remove Add button when array reaches 10 items
    if (this.punchRecordList.length > 9) {
      this.showAddButton = false;
    }
  }


  deletePunchRecord(id) {
    //Make sure validation text is removed
    this.validationPunchRecords = false;

    //Splice out ID of record
    this.punchRecordList.splice(id, 1);

    //Update formatted punchRecordList
    this.convertPunchRecordsFormat();

    //Get total hours
    this.getPunchRecordsHours();

    //Remove storage
    sessionStorage.removeItem("punchRecords");

    //Add new record to local storage
    sessionStorage.setItem('punchRecords', JSON.stringify(this.punchRecordsToView));

    //If one item left in array, do not remove Delete button
    if (this.punchRecordList.length < 2) {
      this.showDeleteButton = false;
    }

    //Show Add button when array less than 10 items
    if (this.punchRecordList.length < 10) {
      this.showAddButton = true;
    }
  }


  getEmployeeList() {
    //Grab employee list based off current store or store selected
    this.PraService.getEmployeeListAndStore(this.storeId)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          data.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
          this.employeeList = data;
          console.log(this.employeeList);

          if (typeof this.params.AssociateEmployeeID !== 'undefined') {

            this.selectedEmployee = this.employeeList[this.params.Index].EmployeeID;
            this.selectedEmployeeName = this.employeeList[this.params.Index].DisplayName;
            this.selectedIndex = this.params.Index;
            this.isWeekly = this.params.IsWeekly;
            this.getPraWeeks();

          } else {

            if (data.length > 0) {
              this.selectedEmployee = this.employeeList[0].EmployeeID;
              this.selectedEmployeeName = this.employeeList[0].DisplayName;
              this.selectedEmployeeHomeStore = this.employeeList[0].HomeStoreID;
              this.selectedIndex = 0;
              this.isWeekly = this.employeeList[0].IsWeekly;
              this.getPraWeeks();
            }

          }

          // For MUM and above: Show request field after selecting a store
          if (this.currentUser.opsLevel == 3) {
            this.addRequestView = true;
          }
        },
        error => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(['/login']);
          } else {
            console.log("API ERROR:");
            console.log(error);
          }
        });
  }

  getPraWeeks() {
    //console.log(`PRA Weeks Store ID: ${this.storeId}`)
    let grid = []
    this.isWeekly
    this.loading = true;
    const result = this.PraService.getGetPRAWeeks(
      this.todayDate,
      this.isWeekly,
      this.storeId
    ).pipe(first())
      .subscribe(
        data => {
          if (this.isWeekly == true) {
            for (const index in data) {
              grid.push(moment(this.formatDataService.formatDateYyyyMmDd(data[index])).subtract(6, 'days').format('MM/DD/YYYY') + ' - ' + moment(this.formatDataService.formatDateYyyyMmDd(data[index])).format('MM/DD/YYYY')
              );
            }
          } else {
            for (const index in data) {
              grid.push(moment(this.formatDataService.formatDateYyyyMmDd(data[index])).subtract(6, 'days').format('MM/DD/YYYY') + ' - ' + moment(this.formatDataService.formatDateYyyyMmDd(data[index])).format('MM/DD/YYYY')
              );
            }
          }

          this.loading = false;
          console.log(grid);
          this.praWeeks = grid;

          if (typeof this.params.AssociateEmployeeID !== 'undefined') {
            //this.isWeekly = this.params.IsWeekly;
            console.log(this.params.PraWeekIndex);
            this.selectedPraWeek = grid[this.params.PraWeekIndex];
            this.selectedPraWeekIndex = this.params.PraWeekIndex;
            this.praDays = this.formatDataService.createDaysOfPayWeek(grid[this.params.PraWeekIndex], this.isWeekly);
            console.log(this.praDays);
            this.selectedBusinessDate = this.praDays[this.params.BusinessDateIndex];
            this.selectedBusinessDateIndex = this.params.BusinessDateIndex;
            console.log(this.params.BusinessDateIndex);

            //Grab Punch Records to maintain state from Local Storage if it exists
            if (sessionStorage.punchRecordList != null) {
              this.punchRecordList = JSON.parse(sessionStorage.getItem('punchRecordList'));
            }

            //Check again when back button is pressed. If more than one item in array, show Delete button
            if (this.punchRecordList.length < 2) {
              this.showDeleteButton = false;
            }


          } else {
            this.selectedPraWeek = grid[0];
            this.selectedPraWeekSnapshot = grid[0];
            this.selectedPraWeekIndexSnapshot = 0;
            this.selectedPraWeekIndex = 0;
            this.praDays = this.formatDataService.createDaysOfPayWeek(grid[0], this.isWeekly)

            console.log(this.praDays);
            this.punchRecordList[0].selectedBusinessDate = this.praDays[0];
            this.selectedBusinessDateIndex = 0;

            //Add default record to session storage
            this.addInitialSessionStorage();

            //Remove PunchRecordsList
            sessionStorage.removeItem("punchRecordList");


          }
          console.log(this.selectedPraWeekIndex)
          console.log(this.selectedPraWeek)

          if (data.isSuccess) {
          } else {
            if (data.ErrMessage) {
              this.consentErrMsg = data.ErrMessage;
            } else {
              this.consentErrMsg = '';
            }
          }

        },
        error => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(['/login']);
          } else {
            this.consentErrMsg = 'Something went wrong, please contact your administrator:' + error;
          }
        });
  }

  openConfirmation() {

    switch (this.continueToNextPage) {
      case false:
        this.showTotalHoursValidation = false;
        break;

      case true:
        //Make sure total hours is not 0 before proceeding to next page
        if (this.totalHours == 0) {
          this.showTotalHoursValidation = true;
        } else {
          this.showTotalHoursValidation = false;

          //Update formatted punchRecordList
          this.convertPunchRecordsFormat();

          //Remove storage
          sessionStorage.removeItem("punchRecords");

          //Add new record to local storage
          sessionStorage.setItem('punchRecords', JSON.stringify(this.punchRecordsToView));

          //Add original punch record list to local storage to maintain state
          sessionStorage.setItem('punchRecordList', JSON.stringify(this.punchRecordList));

          //Pass parameters to confirmation page
          this.router.navigate(['./new-request/confirm'], {
            queryParams: {
              AssociateEmployeeID: this.selectedEmployee,
              AssociateEmployeeName: this.selectedEmployeeName,
              StoreIndex: this.selectedStoreIndex,
              StoreID: this.storeId,
              RequestorEmployeeID: this.currentUser.employeeId,
              RequestorEmployeeName: this.currentUser.displayName,
              TodayDate: this.todayDate,
              SelectedWeek: this.selectedPraWeek,
              Comments: this.comments,
              BusinessDate: this.selectedBusinessDate,
              PunchInHour: this.punchIn.hour,
              PunchInMinute: this.punchIn.minute,
              PunchOutHour: this.punchOut.hour,
              PunchOutMinute: this.punchOut.minute,
              Index: this.selectedIndex,
              PraWeekIndex: this.selectedPraWeekIndex,
              BusinessDateIndex: this.selectedBusinessDateIndex,
              IsWeekly: this.isWeekly,
              TotalHours: this.totalHours,
              HomeStore: this.selectedEmployeeHomeStore
            }
          })

        }

        break;

    }




  }

  convertPunchRecordsFormat() {
    this.punchRecordsToView = []

    for (let index in this.punchRecordList) {

      let punchInDate = this.punchRecordList[index].selectedBusinessDate;

      // Make sure punch out time is next day when choosing 12am thru 3am
      let punchOutDate = function (punchInHour, punchOutHour, date) {
        if ((punchOutHour >= 0 && punchOutHour <= 2) && (punchInHour >= 3 && punchOutHour <= 23)) {
          return moment(date).add(1, 'days').format('MM/DD/YYYY')
        }
        else {
          return moment(date).format('MM/DD/YYYY')
        }
      }

      let punchIn = moment(this.formatDataService.validatePunchInput(punchInDate, this.punchRecordList[index].punchIn.hour, this.punchRecordList[index].punchIn.minute));
      let punchOut = moment(this.formatDataService.validatePunchInput(punchOutDate(this.punchRecordList[index].punchIn.hour, this.punchRecordList[index].punchOut.hour, this.formatDataService.formatDateYyyyMmDdReverse(punchInDate)), this.punchRecordList[index].punchOut.hour, this.punchRecordList[index].punchOut.minute));

      let duration = moment.duration(punchIn.diff(punchOut));
      let hours = duration.asHours();

      if (Math.abs(hours) > 4 && this.selectedStoreState == 'CA') {
        this.showMealBreakAlert = '<div class="alert alert-warning"><b>Meal break warning:</b> Break is recommended after 4 hours</div>';
        this.show3AMAlert = '';
        this.showPunchTimeError = '';
      } else {
        this.showMealBreakAlert = '';
      }

      if (hours > 0) {
        this.showPunchTimeError = 'Your punch out time cannot be before your punch in time';
        this.showMealBreakAlert = '';
        this.show3AMAlert = '';
      } else {
        this.showPunchTimeError = '';
      }

      if ((this.punchRecordList[index].punchIn.hour >= 0 && this.punchRecordList[index].punchIn.hour <= 2) && (this.punchRecordList[index].punchOut.hour >= 3 && this.punchRecordList[index].punchOut.hour <= 23)) {
        this.show3AMAlert = 'Punch in time can only start as early as 3AM';
        this.showPunchTimeError = '';
        this.showMealBreakAlert = '';
      } else {
        this.show3AMAlert = '';
      }

      if ((this.punchRecordList[index].punchOut.hour >= 0 && this.punchRecordList[index].punchOut.hour <= 2) && (this.punchRecordList[index].punchIn.hour >= 3 && this.punchRecordList[index].punchIn.hour <= 23)) {
        this.showPunchIsNextDay = '(Next day: ' + moment(this.formatDataService.formatDateYyyyMmDdReverse(this.punchRecordList[index].selectedBusinessDate)).add(1, 'days').format('MM/DD/YYYY') + ')';
      } else {
        this.showPunchIsNextDay = '';
      }

      this.punchRecordsToView.push(
        {
          BusinessDate: this.punchRecordList[index].selectedBusinessDate,
          punchInDetails: { hour: this.punchRecordList[index].punchIn, minute: this.punchRecordList[index].punchIn.minute },
          punchOutDetails: { hour: this.punchRecordList[index].punchOut, minute: this.punchRecordList[index].punchOut.minute },
          PunchIn: this.formatDataService.formatTime(this.punchRecordList[index].punchIn),
          PunchOut: this.formatDataService.formatTime(this.punchRecordList[index].punchOut),
          PunchInForSubmit: this.formatDataService.formatPunchToSubmit(this.punchRecordList[index].selectedBusinessDate, this.punchRecordList[index].punchIn.hour, this.punchRecordList[index].punchIn.minute),
          PunchOutForSubmit: this.formatDataService.formatPunchToSubmit(this.punchRecordList[index].selectedBusinessDate, this.punchRecordList[index].punchOut.hour, this.punchRecordList[index].punchOut.minute),
          HoursToView: Math.abs(hours).toFixed(2),
          Hours: hours,
          validateMessage: this.showPunchTimeError,
          nextDayAlert: this.showPunchIsNextDay,
          mealBreakWarning: this.showMealBreakAlert,
          show3AMAlert: this.show3AMAlert
        }


      );



    }
    console.log(this.punchRecordsToView);

    let validatePunch = this.punchRecordsToView.find(i => i.validateMessage === 'Your punch out time cannot be before your punch in time');
    let validate3am = this.punchRecordsToView.find(i => i.show3AMAlert === 'Punch in time can only start as early as 3AM');
    if (validatePunch !== undefined || validate3am !== undefined) {
      this.continueToNextPage = false;
    } else {
      this.continueToNextPage = true;
    }
  }

  getPunchRecordsHours() {
    var hoursArray = [];
    for (let index in this.punchRecordsToView) {
      hoursArray.push(
        Math.abs(this.punchRecordsToView[index].Hours.toFixed(2))
      );
    }

    console.log(hoursArray);

    const sum = hoursArray.reduce(add, 0); // with initial value to avoid when the array is empty

    function add(accumulator, a) {
      return accumulator + a;
    }

    this.totalHours = Math.abs(sum.toFixed(2))

    console.log(this.totalHours);

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}
